import getBrowserLanguage from '../utils/languageDetector';

export const login = (
  email,
  password,
  antibotStirng = '',
  { tokenLink, partnerToken, hiddenEmployeeToken },
) => async () => {
  const res = await fetch('/auth/local', {
    credentials: 'include',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: email.trim(),
      password,
      name: antibotStirng,
      tokenLink,
      partnerToken,
      hiddenEmployeeToken,
    }),
  });
  return res;
};

export const createDemoAccount = () => () =>
  fetch('/auth/demo', {
    credentials: 'include',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ language: getBrowserLanguage() }),
  })
    .then((res) => {
      if (res.status < 400) {
        window.location = process.env.UNICAT_DEFAULT_SERVICE;
        return Promise.resolve();
      }
      return Promise.reject(new Error(`${res.status}: ${res.statusText}, Url: ${res.url}`));
    })
    .catch((e) => Promise.reject(e));



// WEBPACK FOOTER //
// ./action-creators/login.js